import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=f27f5218"
import script from "./Maintenance.vue?vue&type=script&lang=ts"
export * from "./Maintenance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports